import tw, { styled } from 'twin.macro';

const Heading = styled.h1(({ variant = 'default', weight }) => [
  tw`font-primary mt-4 mb-4 font-bold`,
  variant === 'default' && tw`text-2xl`,
  variant === 'base' && tw`text-base`,
  variant === 'large' && tw`text-xl font-medium`,
  weight === 'bold' && tw`font-bold`,
]);

export default Heading;
